export function canReadClipboard(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    typeof navigator.clipboard?.read === 'function'
  );
}

/**
 * First image on the system clipboard (async Clipboard API), or `null` when it
 * holds none. Rejects when the browser refuses the read (permission, focus).
 */
export async function readClipboardImage(
  clipboard: Pick<Clipboard, 'read'> = navigator.clipboard
): Promise<File | null> {
  const items = await clipboard.read();
  for (const item of items) {
    const type = item.types.find(candidate => candidate.startsWith('image/'));
    if (type) {
      const blob = await item.getType(type);
      return new File([blob], `clipboard.${type.slice('image/'.length)}`, {
        type
      });
    }
  }
  return null;
}
